import {
  DeleteOutlined,
  EditOutlined,
  FileAddOutlined,
  InboxOutlined,
  LeftOutlined,
  LoadingOutlined,
  MessageOutlined,
  PlusOutlined,
  RightOutlined
} from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Modal,
  Row,
  Spin,
  Switch,
  Typography,
  Upload,
  message
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import Dragger from 'antd/lib/upload/Dragger';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Document, Page } from 'react-pdf';
import { SizeMe } from 'react-sizeme';
import { SubSubtitle } from '../../../../../components';
import CardDocumentPreview360 from '../../../../../components/CardDocumentPreview360';
import CustomCopyable from '../../../../../components/CustomCopyable';
import Image360 from '../../../../../components/Image360';
import ResponsiveContainer from '../../../../../components/ResponsiveContainer';
import { CONFIG, compressionOptions } from '../../../../../constants';
import EmpresaContext from '../../../../../context/empresa-context';
import { useSiniestroContext } from '../../../../../context/siniestro-context';
import {
  isEmpty,
  validateCedulaIdentidad
} from '../../../../../functions/images';
import {
  errorHandler,
  heicAndheifConvert,
  myImageCompression
} from '../../../../../utils';
import { instanceRef } from '../../../../../utils/axios';

const DocumentosPersonales = () => {
  const {
    datosSiniestro,
    setLoading,
    documentosAdicionales,
    setDocumentosAdicionales,
    setComentario,
    comentario,
    getSiniestro,
    documento1,
    setDocumento1,
    cedula1,
    setCedula1,
    cedula2,
    setCedula2,
    sendEmail,
    deleteFile
  } = useSiniestroContext();

  const { executeRecaptcha } = useGoogleReCaptcha();

  const [showComentario, setShowComentario] = useState(
    !!datosSiniestro.comentario
  );
  const [loadingBefore, setLoadingBefore] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [dialogConfig, setDialogConfig] = useState(false);
  const [loadingEmail, setLoadingEmail] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const { empresa } = useContext(EmpresaContext);

  const { Title, Paragraph } = Typography;
  const formatosDoc =
    'image/jpeg,image/heif,image/heic, image/png, application/pdf';
  const formatos = 'image/jpeg,image/heif,image/heic, image/png';

  function onDocumentLoadSuccess({ numPages: nextNumPages }) {
    setNumPages(nextNumPages);
  }

  const nextPage = () => {
    if (currentPage < numPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const previousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const cedulaAdelanteUpload = () => (
    <div>
      <Upload
        style={{ width: 'auto !important' }}
        name="avatar"
        accept={formatos}
        listType="picture-card"
        className={`avatar-uploader ${cedula1 ? 'success' : 'error'}`}
        showUploadList={false}
        customRequest={(e) => uploadFile(e, 'CIA', setCedula1, setLoading1)}
        beforeUpload={(e) => beforeUpload(e, setLoadingBefore)}
        disabled={loading1 || loading2 || loading3}
      >
        {cedula1 ? (
          <img src={cedula1.imagen} alt="avatar" style={{ width: '100%' }} />
        ) : (
          <div style={{ paddingBottom: 2 }}>
            {loading1 ? <LoadingOutlined /> : <PlusOutlined />}
            {!loading1 && (
              <>
                <div className="ant-upload-text">(Frente)</div>
                <img
                  src="/images/cedula_adelante.png"
                  alt="avatar"
                  style={{ width: '100%' }}
                />
              </>
            )}
          </div>
        )}
      </Upload>
    </div>
  );

  async function beforeUpload(file, setLoadingImagen) {
    setLoadingImagen(true);
    const isJpgOrPng =
      file.type === 'image/jpeg' ||
      file.type === 'image/heif' ||
      file.type === 'image/heic' ||
      file.type === 'image/png';
    if (!isJpgOrPng) {
      message.warning('El formato del archivo no está permitido.');
    }
    const isLt10M =
      file.size /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 <
      2;
    if (!isLt10M) {
      message.warning('El tamaño de la imagen debe ser inferior a 10MB.');
    }
    setLoadingImagen(false);
    return isJpgOrPng && isLt10M;
  }

  const uploadFile = async (file, type, setter, loading) => {
    try {
      setLoading(true);
      loading(true);
      const reCaptchaToken = await executeRecaptcha('file/upload');
      const converted = await heicAndheifConvert(file.file);
      const compressedFile = await myImageCompression(
        converted,
        compressionOptions
      );
      const formData = new FormData();
      formData.append('cedula', compressedFile);
      formData.append('reCaptchaToken', reCaptchaToken);
      // formData.append('token', token);
      formData.append('empresaId', empresa.id);
      formData.append(
        'aseguradoraId',
        datosSiniestro.poliza.solicitud.cotizacion.aseguradoraEmpresa
          .id_aseguradora
      );
      formData.append(
        'cotizacionId',
        datosSiniestro.poliza.solicitud.id_cotizacion
      );
      if (type !== 'HAD' && type !== 'HAA') {
        // Si es cedula verde no se llama al servicio
        const response = await instanceRef.instance.post(
          `file/upload?tipo=${type}`,
          formData,
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        );
        const fileData = response.data.data;
        switch (type) {
          case 'CIA':
            validateCedulaIdentidad(fileData, 'CIA').then((isValid) => {
              if (!isEmpty(isValid)) {
                errorHandler(null, isValid);
                loading(false);
                setCedula1('');
              } else {
                getBase64(compressedFile, (imageUrl) => {
                  setter({
                    imagen: imageUrl,
                    extension: compressedFile.type.split('/')[1],
                    nombre: `${type}.${compressedFile.type.split('/')[1]}`
                  });
                  loading(false);
                });
              }
            });
            break;
          case 'CID':
            validateCedulaIdentidad(fileData, 'CID').then((isValid) => {
              if (!isEmpty(isValid)) {
                errorHandler(null, isValid);
                loading(false);
                setCedula2('');
              } else {
                getBase64(compressedFile, (imageUrl) => {
                  setter({
                    imagen: imageUrl,
                    extension: compressedFile.type.split('/')[1],
                    nombre: `${type}.${compressedFile.type.split('/')[1]}`
                  });
                  loading(false);
                });
              }
            });

            break;
          default:
            break;
        }
        setLoading(false);
      }
    } catch (error) {
      errorHandler(error, 'Error al subir el archivo');
      loading(false);
    }
  };

  const cedulaAtrasUpload = () => (
    <div>
      <Upload
        style={{ width: 'auto !important' }}
        name="avatar"
        accept={formatos}
        listType="picture-card"
        className={`avatar-uploader ${cedula2 ? 'success' : 'error'}`}
        showUploadList={false}
        customRequest={(e) => uploadFile(e, 'CID', setCedula2, setLoading2)}
        beforeUpload={(e) => beforeUpload(e, setLoadingBefore)}
        disabled={loading1 || loading2 || loading3}
      >
        {cedula2 ? (
          <img src={cedula2.imagen} alt="avatar" style={{ width: '100%' }} />
        ) : (
          <div style={{ paddingBottom: 2 }}>
            {loading2 ? <LoadingOutlined /> : <PlusOutlined />}
            {!loading2 && (
              <>
                <div className="ant-upload-text">(Dorso)</div>
                <img
                  src="/images/cedula_atras.png"
                  alt="avatar"
                  style={{ width: '100%' }}
                />
              </>
            )}
          </div>
        )}
      </Upload>
    </div>
  );

  const getSiniestroFiles = async (siniestro) => {
    setLoading(true);
    const documentos = [];
    try {
      const files = await instanceRef.instance.get(
        `/siniestro/files/${siniestro.token}?sinform=true`
      );

      const baseURL = CONFIG.URL_BASE;
      const docs = files.data.data.map((item) => ({
        ...item,
        extension: item.descripcion.split('.')[1],
        imagen: `${baseURL}/siniestro/file/${siniestro.token}?id=${item.id}`
      }));
      // Settear states
      docs.forEach((element) => {
        if (element.descripcion.includes('CIA'))
          setCedula1({ imagen: element.url });
        else if (element.descripcion.includes('CID'))
          setCedula2({ imagen: element.url });
        else if (element.descripcion.includes('documento1'))
          setDocumento1(element);
        else documentos.push(element);
      });
      setDocumentosAdicionales(documentos);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const DocumentoUpload = ({
    name,
    loading,
    setLoadingUpload,
    setDocumento
  }) => (
    <div style={{ height: 250 }}>
      <Dragger
        style={{ height: 250, width: 200 }}
        name={name}
        accept={formatosDoc}
        listType="picture-card"
        className={`avatar-uploader ${loading ? 'success' : 'error'}`}
        showUploadList={false}
        customRequest={(e) =>
          uploadFileDoc(e, name, setDocumento, setLoadingUpload)
        }
        beforeUpload={(e) => beforeUploadPDF(e, setLoadingBefore)}
        disabled={loading}
      >
        <div>
          {loading && <LoadingOutlined style={{ fontSize: 18 }} />}
          {!loading && (
            <>
              <div style={{ margin: '10px' }}>
                <p>
                  Factura de Gastos <br />
                  Informe o Estudios médicos
                </p>
              </div>

              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p
                className="ant-upload-text"
                style={{ width: '150px', margin: 'auto' }}
              >
                Click o arrastrar archivo para subir
              </p>
            </>
          )}
        </div>
      </Dragger>
    </div>
  );

  const DocumentCard = ({
    name,
    loading,
    setLoadingUpload,
    documento,
    setDocumento
  }) => (
    <Card
      bodyStyle={{ padding: '0px' }}
      cover={
        <div>
          {loading && <LoadingOutlined style={{ fontSize: 18 }} />}
          {!loading && (
            <>
              {documento ? (
                <>
                  {documento.extension !== 'pdf' && (
                    <Card
                      bodyStyle={{ height: 200, width: 141, padding: '0px' }}
                    >
                      <Image360
                        src={documento.imagen}
                        alt="avatar"
                        style={{
                          maxWidth: 140,
                          height: 195,
                          objectFit: 'contain'
                        }}
                      />
                    </Card>
                  )}{' '}
                  {documento.extension === 'pdf' && (
                    <CardDocumentPreview360
                      cardProps={{
                        onClick: () => {
                          setDialogConfig({
                            open: true,
                            content: documento.imagen,
                            title: ''
                          });
                        }
                      }}
                      documentProps={{
                        file: documento.imagen,
                        onLoadSuccess: onDocumentLoadSuccess
                      }}
                    />
                  )}
                </>
              ) : null}
            </>
          )}
        </div>
      }
      actions={[
        <Upload
          style={{ width: 'auto !important' }}
          accept={formatosDoc}
          showUploadList={false}
          customRequest={(e) =>
            uploadFileDoc(e, name, setDocumento, setLoadingUpload)
          }
          beforeUpload={(e) => beforeUploadPDF(e, setLoadingBefore)}
        >
          <EditOutlined />
        </Upload>
      ]}
    />
  );

  const DocumentCardAdicional = ({ index }) => (
    <Card
      bodyStyle={{ padding: '0px' }}
      cover={
        <div>
          {loadingBefore && <LoadingOutlined style={{ fontSize: 18 }} />}
          {!loadingBefore && (
            <>
              {documentosAdicionales[index] ? (
                <>
                  {documentosAdicionales[index].extension !== 'pdf' && (
                    <Card
                      bodyStyle={{ height: 200, width: 141, padding: '0px' }}
                    >
                      <Image360
                        src={documentosAdicionales[index].imagen}
                        alt="avatar"
                        style={{
                          maxWidth: 140,
                          height: 200,
                          objectFit: 'contain'
                        }}
                      />
                    </Card>
                  )}{' '}
                  {documentosAdicionales[index].extension === 'pdf' && (
                    <CardDocumentPreview360
                      cardProps={{
                        onClick: () => {
                          setDialogConfig({
                            open: true,
                            content: documentosAdicionales[index].imagen,
                            title: ''
                          });
                        }
                      }}
                      documentProps={{
                        file: documentosAdicionales[index].imagen,
                        onLoadSuccess: onDocumentLoadSuccess
                      }}
                    />
                  )}
                </>
              ) : null}
            </>
          )}
        </div>
      }
      actions={[
        <Upload
          style={{ width: 'auto !important' }}
          accept={formatosDoc}
          showUploadList={false}
          customRequest={(e) =>
            uploadFileDocAdicional(e, `documento${index + 2}`, index)
          }
          beforeUpload={(e) => beforeUploadPDF(e, setLoadingBefore)}
        >
          <EditOutlined />
        </Upload>,
        <DeleteOutlined
          onClick={() => {
            deleteFile(index);
          }}
        />
      ]}
    />
  );

  async function beforeUploadPDF(file, setLoadingImagen) {
    setLoadingImagen(true);
    const isPdf = file.type === 'application/pdf';
    const isJpgOrPng =
      file.type === 'image/jpeg' ||
      file.type === 'image/heif' ||
      file.type === 'image/heic' ||
      file.type === 'image/png';

    if (!isPdf && !isJpgOrPng) {
      message.error('El formato del archivo no está permitido.');
    }
    const isLt10M =
      file.size /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 <
      2;
    if (!isLt10M) {
      message.warning('El tamaño de la imagen debe ser inferior a 10MB.');
    }
    setLoadingImagen(false);
    return (isPdf || isJpgOrPng) && isLt10M;
  }

  const uploadFileDoc = async (file, type, setter, loading) => {
    try {
      setLoading(true);
      loading(true);
      getBase64(file.file, (imageUrl) => {
        setter({
          imagen: imageUrl,
          extension: file.file.type.split('/')[1],
          nombre: `${type}.${file.file.type.split('/')[1]}`
        });
        loading(false);
      });
    } catch (error) {
      errorHandler(error, 'Error al subir el archivo');
      loading(false);
    }
  };

  const uploadFileDocAdicional = async (file, type, index) => {
    try {
      setLoading(true);
      const docs = documentosAdicionales;
      getBase64(file.file, (imageUrl) => {
        const archivo = {
          imagen: imageUrl,
          extension: file.file.type.split('/')[1],
          nombre: `${type}.${file.file.type.split('/')[1]}`
        };
        if (docs[index]) docs[index] = archivo;
        else docs.push(archivo);
        setDocumentosAdicionales(docs);
        setLoading(false);
      });
    } catch (error) {
      setLoading(false);
      errorHandler(error, 'Error al subir el archivo');
    }
  };

  const ButtonExtraFile = () => {
    if (documento1)
      return (
        <Upload
          style={{ width: 'auto !important' }}
          accept={formatosDoc}
          showUploadList={false}
          customRequest={(e) => uploadFileDocAdicional(e, `documento4`)}
          beforeUpload={(e) => beforeUploadPDF(e, setLoadingBefore)}
        >
          <div>
            <Card
              cover={
                <Button type="dashed" shape="round">
                  <FileAddOutlined /> Agregar Documento adicional
                </Button>
              }
              bodyStyle={{ padding: '0' }}
              style={{
                border: 0,
                marginBottom: 20
              }}
            />

            <div className="background-hover" />
          </div>
        </Upload>
      );
    return <></>;
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    getSiniestro(datosSiniestro.token);
    getSiniestroFiles(datosSiniestro);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const preview = useCallback(() => {
    if (documento1)
      return (
        <DocumentCard
          name="documento1"
          loading={loading3}
          setLoadingUpload={setLoading3}
          documento={documento1}
          setDocumento={setDocumento1}
        />
      );
    return (
      <DocumentoUpload
        label="Tipo de documento"
        name="documento1"
        loading={loading3}
        setLoadingUpload={setLoading3}
        setDocumento={setDocumento1}
      />
    );
  }, [documento1, loading3, setDocumento1]);

  const previewAdicional = useCallback(
    (index) => {
      if (documentosAdicionales[index])
        return <DocumentCardAdicional index={index} />;
      return <></>;
    },
    [documentosAdicionales]
  );

  return (
    <>
      <ResponsiveContainer style={{ marginTop: '1em' }}>
        <Spin
          spinning={loading1 || loading2 || loading3}
          delay={500}
          size="large"
          tip="Cargando..."
        >
          {' '}
          <Row style={{ marginTop: '40px', justifyContent: 'center' }}>
            <Title level={4}>
              Favor Cargar las Fotografías y Documentos Adicionales{' '}
            </Title>
            <div>
              <Paragraph align="left">
                Los documentos del siniestro pueden ser subidos desde su
                Dispositivo Móvil / Celular, continuando el proceso.
              </Paragraph>
              <Paragraph align="left">
                <span>
                  En caso que desee subirlos desde un{' '}
                  <span style={{ fontWeight: 'bold' }}>
                    Dispositivo de Escritorio (PC, Notebook)
                  </span>
                  :
                </span>
                <Button
                  type="text"
                  icon={
                    <CustomCopyable
                      copyable={{
                        text: `${window.location.origin}/siniestros/form/${datosSiniestro.token}/desktop`,
                        tooltips: [
                          'Copiar enlace para subir documentos en computadora',
                          'Copiado'
                        ]
                      }}
                    />
                  }
                  size="middle"
                />
                <Button
                  type="text"
                  onClick={() => {
                    setLoadingEmail(true);
                    sendEmail();
                  }}
                  icon={<MessageOutlined />}
                  loading={loadingEmail}
                >
                  Enviar por E-mail
                </Button>
              </Paragraph>
            </div>
          </Row>
          <Row style={{ justifyContent: 'center' }}>
            <Row style={{ margin: '0px 30px 0px 30px' }}>
              <Col
                xs={24}
                sm={24}
                style={{ margin: '10px', justifyContent: 'space-between' }}
              >
                {' '}
                <Row>
                  <Col xs={24} sm={24}>
                    <SubSubtitle>Cédula de Identidad</SubSubtitle>
                  </Col>{' '}
                </Row>
                <Row>
                  <Col xs={24} sm={12}>
                    {cedulaAdelanteUpload()}
                  </Col>
                  <Col xs={24} sm={12}>
                    {cedulaAtrasUpload()}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Row>
          <Row style={{ marginTop: '40px', justifyContent: 'center' }}>
            <SubSubtitle>Otros documentos</SubSubtitle>
          </Row>
          <Row justify="center" style={{ textAlign: 'start' }}>
            <Row justify="center" style={{ textAlign: 'start' }}>
              <Col style={{ margin: '5px' }}>{preview()}</Col>
              {documentosAdicionales.map((documento, i) => (
                <Col style={{ margin: '5px' }} key={i}>
                  {previewAdicional(i)}
                </Col>
              ))}
            </Row>
          </Row>
          <Modal
            bodyStyle={{ padding: 0, paddingBottom: 20 }}
            style={{ maxWidth: 1000 }}
            className="modal-header-document"
            centered
            open={dialogConfig.open}
            afterClose={() =>
              setDialogConfig({
                open: false,
                content: undefined,
                title: ''
              })
            }
            onCancel={() =>
              setDialogConfig({
                open: false,
                content: undefined,
                title: ''
              })
            }
            footer={null}
            width="90%"
          >
            <div>
              {dialogConfig.content && (
                <SizeMe>
                  {({ size }) => (
                    <Document
                      onLoadSuccess={onDocumentLoadSuccess}
                      loading={<Spin style={{ padding: 20 }} />}
                      file={dialogConfig.content}
                    >
                      <Page
                        key={`page_${currentPage + 1}`}
                        pageNumber={currentPage + 1}
                        width={size.width ? size.width : 1}
                      />
                      <div style={{ textAlign: 'center' }}>
                        <Button
                          type="link"
                          onClick={() => previousPage()}
                          disabled={currentPage === 0}
                        >
                          <LeftOutlined />
                          Anterior
                        </Button>
                        Pág. {currentPage + 1} de {numPages}
                        <Button
                          type="link"
                          onClick={() => nextPage()}
                          disabled={currentPage + 1 === numPages}
                        >
                          Siguiente
                          <RightOutlined />
                        </Button>
                      </div>
                    </Document>
                  )}
                </SizeMe>
              )}
            </div>
          </Modal>
          <Row style={{ marginTop: '20px', justifyContent: 'center' }}>
            <Col xs={24} md={8}>
              {ButtonExtraFile()}
            </Col>
          </Row>
          <Row style={{ marginTop: '40px', justifyContent: 'center' }}>
            <Title level={4}>Comentarios adicionales</Title>
          </Row>
          <Row style={{ marginTop: '40px' }}>
            <Col xs={24}>
              <p>
                ¿Desea agregar un comentario?
                <Switch
                  checked={showComentario}
                  onChange={(value) => {
                    setShowComentario(value);
                  }}
                  style={{ marginLeft: '10px' }}
                />
              </p>
            </Col>
            <Col xs={24}>
              {showComentario && (
                <TextArea
                  placeholder="Escribir comentario"
                  value={comentario}
                  rows={4}
                  onChange={(e) => {
                    setComentario(e.target.value);
                  }}
                />
              )}
            </Col>
          </Row>
        </Spin>
      </ResponsiveContainer>
    </>
  );
};

export default DocumentosPersonales;
